import { Injectable } from '@angular/core';

@Injectable()
export class DBkeys {

  public static readonly CURRENT_USER = 'current_user';
  public static readonly USER_PERMISSIONS = 'user_permissions';

  public static readonly REMEMBER_ME = 'remember_me';

  public static readonly LOCAL_KEY_REG = 'registerData';
  public static readonly LOCAL_KEY_ISCLAIM = 'registerIsClaim';
  public static readonly LOCAL_KEY_PID = 'registerPID';
  public static readonly LOCAL_KEY_CORP = 'registerCORP';
  public static readonly LOCAL_KEY_EMAIL = 'registerEmail';

  public static readonly HOME_URL = 'home_url';

  public static readonly CONTENT_DETAILS = 'content_details';
}
